import { create } from '@storybook/theming';

export default create({
  colorPrimary: '#001758o',
  colorSecondary: '#FF672F',
  base: 'light',
  brandTitle: 'CitizenLab',
  brandImage:
    './logo.png',
  brandTarget: '_self',
});
